// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EjyT","content":"styles_content__MEG7E"};